/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */
import { Image } from 'components/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Erika est inséminée pour la troisième fois. Mais l’imprégnation ne marche qu’à la quatrième
tentative. Sa fécondité baisse. Elle donne d’autant plus de lait: près de 40 litres par
jour après son troisième veau. Un contrôleur mandaté par le Canton passe dans la ferme
où vit Erika. S’il détecte des manquements, les paiements directs seront réduits. S’il
relève de graves infractions au bien-être animal, il les annonce au vétérinaire
cantonal. D’autres contrôles suivent alors; dans les cas extrêmes, plainte pénale sera
déposée auprès du ministère public. Mais tout est en ordre dans la ferme d’Erika. C’est
une exception. Dans le canton de St-Gall en 2018 par exemple, les collaborateurs du
vétérinaire cantonal ont effectués 253 inspections. Ils ont trouvé des manquements dans
175 fermes (69%). Il y a eu 45 plaintes, soit une ferme sur cinq contrôlées.`}</p>
    </MDXLayout>;
}

MDXContent.isMDXComponent = true;
  